// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-action-template/src/index.tsx

// TODO: Check if the icon is alined properly.
// If it is not: Replace/extend defaultAlignedActionIconGroupProps to make it look right.
// https://stash.int.klarna.net/projects/UI/repos/bubble-ui/pull-requests/121/overview?commentId=2244923
import baseIcon, { defaultAlignedActionIconGroupProps } from '@bubble-ui/temp-icon-base';
var ActionIconLanguagePath = 'M12 6A6 6 0 1 0 0 6a6 6 0 0 0 12 0ZM2 6c0-.38.053-.748.152-1.096 1.283.395 2.565.593 3.848.593s2.565-.198 3.848-.593a4.002 4.002 0 0 1 .136 1.461A13.056 13.056 0 0 1 6 7c-1.328 0-2.656-.212-3.984-.635A4.05 4.05 0 0 1 2 6Zm.993 2.638A3.99 3.99 0 0 0 6 10a3.99 3.99 0 0 0 3.007-1.362A12.816 12.816 0 0 1 6 9c-1.002 0-2.004-.12-3.007-.362ZM6 3.497a12.78 12.78 0 0 1-2.833-.321A3.988 3.988 0 0 1 6 2c1.107 0 2.108.45 2.832 1.176A12.78 12.78 0 0 1 6 3.496Z';
var ActionIconLanguage = baseIcon('ActionIconLanguage', {
  groupProps: defaultAlignedActionIconGroupProps,
  getPath: () => ActionIconLanguagePath
});
export default ActionIconLanguage;
//# sourceMappingURL=index.js.map